module.exports = __webpack_public_path__ + "static/media/geogames_maps.28187f78.png";